
import { defineComponent } from 'vue';
import {
  dismissDialog, getDialogComponent, getDialogProps, isDialogVisible,
} from '~/plugins/dialog/state';

export default defineComponent({
  name: 'GlobalDialog',

  computed: {
    component() {
      return getDialogComponent();
    },

    props() {
      return getDialogProps();
    },

    isVisible() {
      return isDialogVisible();
    },
  },

  methods: {
    dismissDialog() {
      dismissDialog();
    },
  },
});
